{
  "title": "Weird",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level illusion",
  "level": 9,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Drawing on the deepest fears of a group of creatures, you create illusory creatures in their minds, visible only to them.",
    "Each creature in a 30-foot-radius sphere centered on a point of your choice within range must make a Wisdom saving throw. On a failed save, a creature becomes frightened for the duration.",
    "The illusion calls on the creature’s deepest fears, manifesting its worst nightmares as an implacable threat. At the end of each of the frightened creature’s turns, it must succeed on a Wisdom saving throw or take 4d10 psychic damage. On a successful save, the spell ends for that creature."
  ],
  "spellLists": ["warlock", "wizard"]
}
